import { redirect } from 'react-router-dom';

import { store } from 'src/app/store';
import { gb, gbPromise } from 'src/common/growthbook';
import { commonEndpoints } from 'src/common/slices';
import { WorkspaceEndpoints } from 'src/features/management-dashboard/workspace/workspace.slice';

export const requireBusinessUserOrCorporatePartner = async () => {
  const query = store.dispatch(commonEndpoints.getUser.initiate());
  try {
    const { data } = await query.unwrap();
    const isBusinessUser = data?.user?.subscriptions?.some((sub) => sub.type === 'company' && sub.status === 'active');
    const isCorporatePartner = data?.user.companies.length;
    if (!isBusinessUser && !isCorporatePartner) throw new Error('user is not part of the company');
  } catch {
    return redirect('/login');
  } finally {
    query.unsubscribe();
  }
  return null;
};

export const requiredWokrspaceUser = async () => {
  const workspaceQuery = store.dispatch(WorkspaceEndpoints.getWorkspace.initiate(undefined, {}));

  try {
    const { data: workspaceData } = await workspaceQuery;
    if (!workspaceData?.hasJoinedWorkspace) throw new Error('user is not part of any workspace');
  } catch {
    return redirect('/workspace');
  } finally {
    workspaceQuery.unsubscribe();
  }
  return null;
};

export const requiredCtfBuilderV2Disabled = async () => {
  try {
    await gbPromise;
    if (!gb.isOn('ctf-builder-v2')) {
      return null;
    }
    return redirect('/workspace');
  } catch {
    return redirect('/dashboard');
  }
};
